import {TreeSelect} from "antd";

const {TreeNode} = TreeSelect;

function printChildren(data, parent) {

  let dataParents = data.filter(item => item.parent == parent);

  return (
    dataParents.map((item,index) => (
      <TreeNode key={index} value={item.id} title={item.name}>
        {printChildren(data, item.id)}
      </TreeNode>
    ))
  )
}

export default function TreeSearchSelectByParentID({data, value, onChange}) {
  return (
    <TreeSelect
      showSearch
      style={{width: '100%'}}
      dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
      placeholder="انتخاب کنید"
      allowClear
      treeDefaultExpandAll
      treeNodeFilterProp='title'
      treeLine
      value={value}
      onChange={onChange}
    >
      {printChildren(data, null)}
    </TreeSelect>
  )
}

